module.exports = __webpack_public_path__ + "assets/images/01_213fbbe06e7e8e0f3a7cb6a4c14421ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-2/01.png
// module id = 232
// module chunks = 0